<template>
  <el-form

    ref="form"
    label-width="170px"
    class="contract-form"
    :model="contractForm"
    :rules="rules"
  >
    <el-form-item label="业务类型">
      <el-radio-group v-model="contractForm.type">
        <el-radio label="1">托乐乐</el-radio>
        <el-radio label="2">天天陪读</el-radio>
        <el-radio label="3">素质学</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="支持课时包类型">
      <el-checkbox-group v-model="contractForm.order_type">
        <el-checkbox v-for="(value,key) in orderType" :key="value" :label="key">{{ value }}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="是否显示接校">
      <el-checkbox v-model="contractForm.is_show_receive" :true-label="1" :false-label="0">是否显示接校</el-checkbox>
    </el-form-item>
    <el-form-item label="是否显示原价">
      <el-checkbox v-model="contractForm.is_show_original_price" :true-label="1" :false-label="0">是否显示原价</el-checkbox>
    </el-form-item>

    <el-form-item label="合同名称" prop="title">
      <el-input v-model="contractForm.title" />
    </el-form-item>
    <el-form-item label="甲方" prop="first_party">
      <el-input v-model="contractForm.first_party" />
    </el-form-item>
    <el-form-item label="乙方" prop="second_party">
      <el-input v-model="contractForm.second_party" />
    </el-form-item>
    <el-form-item label="注意事项">
      <div v-for="(item,index) in contractForm.emphasis" :key="index+'warning'" style="margin-bottom:20px" class="wq_flex">
        <el-input v-model="item.content" style="width: 600px;" />
        <!-- <el-checkbox v-model="item.font"  :true-label="1" :false-label="2">间距加长</el-checkbox> -->
        <el-checkbox v-model="item.strong" style="margin-left:20px" true-label="true" false-label="false">加粗</el-checkbox>
        <el-button style="margin-left:20px" type="danger" size="mini" @click="contractForm.emphasis.splice(index,1)">删除</el-button>
      </div>
      <el-button type="success" size="middle" @click="addWarning()">新增注意事项</el-button>
    </el-form-item>
    <el-form-item label="正文标题" prop="content_title">
      <el-input v-model="contractForm.content_title" />
    </el-form-item>
    <el-form-item label="正文内容">
      <el-table ref="dragTable" :key="aaaa" :data="contractForm.content" row-key="id" :show-header="false" style="margin-bottom:20px;" width="100%">
        <el-table-column width="600px">
          <template slot-scope="{row}">
            <el-input v-model="row.content" style="width: 100%;" />
          </template>
        </el-table-column>
        <el-table-column width="280px">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.font" style="margin-left:20px" :true-label="1" :false-label="2">间距加长</el-checkbox>
            <el-checkbox v-model="scope.row.strong" true-label="true" false-label="false">加粗</el-checkbox>
            <el-button style="margin-left:20px" type="danger" size="mini" @click="contractForm.content.splice(scope.$index,1)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div v-for="(item,index) in contractForm.content" :key="index+'content'" style="margin-bottom:20px" class="wq_flex">
        <el-input v-model="item.content" style="width: 600px;" />
        <el-checkbox v-model="item.font" style="margin-left:20px" :true-label="1" :false-label="2">间距加长</el-checkbox>
        <el-checkbox v-model="item.strong" true-label="true" false-label="false">加粗</el-checkbox>
        <el-button style="margin-left:20px" type="danger" size="mini" @click="contractForm.content.splice(index,1)">删除</el-button>
      </div> -->
      <el-button type="success" size="middle" @click="addMainContent()">新增正文内容</el-button>
    </el-form-item>
    <el-form-item label="合同专用章" prop="picture_url">
      <UploadImg
        :photo.sync="contractForm.picture_url"
        :name="'picture_url'"
        @updateImg="updatePhoto"
      />
      <div class="upload-notice">请上传200*200像素的图片</div>
    </el-form-item>
    <el-form-item label="公众号二维码">
      <UploadImg
        :photo.sync="contractForm.qr_url"
        :name="'qr_url'"
        @updateImg="updatePhoto"
      />
      <div class="upload-notice">请上传200*200像素的图片</div>
    </el-form-item>
    <el-button type="primary" size="large" @click="fnSubmit()">提交</el-button>
  </el-form>
</template>
<script>

// import Select from '@/components/Select'
import UploadImg from '@/components/toolbar/UploadImg.vue'
import { validateRequire } from '@/utils/validate'
import Sortable from 'sortablejs'

export default {
  name: 'AddFood',
  components: {
    UploadImg
  },
  props: {

  },
  data() {
    return {
      newList: [],
      oldList: [],
      aaaa: 0,
      contractForm: {
        id: '',
        type: 1,
        order_type: [],
        title: '',
        picture_url: '',
        content_title: '',
        content: [],
        qr_url: '',
        first_party: '',
        second_party: '',
        emphasis: [],
        is_show_receive: '',
        is_show_original_price: '',
        item_list: ''
      },
      orderType: {},
      rules: {
        order_type: [{ validator: validateRequire, trigger: 'manual', message: '课时包类型' }],
        title: [{ validator: validateRequire, trigger: 'manual', message: '合同标题' }],
        picture_url: [{ validator: validateRequire, trigger: 'manual', message: '合同章' }],
        content_title: [{ validator: validateRequire, trigger: 'manual', message: '正文标题' }],
        // content: [{ validator: validateRequire, trigger: 'manual', message: '正文内容' }],
        first_party: [{ validator: validateRequire, trigger: 'manual', message: '甲方' }],
        second_party: [{ validator: validateRequire, trigger: 'manual', message: '乙方' }]
        // emphasis: [{ validator: validateRequire, trigger: 'manual', message: '须知' }]
      }
    }
  },
  created() {

  },
  mounted() {
    this.contractForm.id = this.$route.query.id || ''
    if (this.contractForm.id) {
      this.fnGetContactInfo()
    }
    this.fnGetTypeInfo()
  },
  methods: {
    displaya(row) {
      console.log(row)
    },
    fnGetContactInfo() {
      this.$http.getContractInfo({ id: this.contractForm.id }).then(res => {
        res.data.content = JSON.parse(res.data.content)
        res.data.emphasis = JSON.parse(res.data.emphasis)
        if (res.data.order_type) {
          res.data.order_type = res.data.order_type && res.data.order_type.split(',')
        } else {
          res.data.order_type = []
        }

        this.contractForm = Object.assign(this.contractForm, res.data)
        this.contractForm.content.forEach((item, index) => {
          item.id = index
        })
        this.$nextTick(() => {
          this.setSort()
        })
      })
    },

    addWarning() {
      console.log(this.contractForm.emphasis)
      this.contractForm.emphasis.push({
        content: '',
        strong: 'false',
        font: 2
      })
    },
    setSort() {
      const el = this.$refs.dragTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost', // Class name for the drop placeholder,
        setData: function(dataTransfer) {
          // to avoid Firefox bug
          // Detail see : https://github.com/RubaXa/Sortable/issues/1012
          dataTransfer.setData('Text', '')
        },
        onEnd: evt => {
          console.log(evt)
          const targetRow = this.contractForm.content.splice(evt.oldIndex, 1)[0]
          this.contractForm.content.splice(evt.newIndex, 0, targetRow)
          // const tempIndex = this.newList.splice(evt.oldIndex, 1)[0]
          // this.newList.splice(evt.newIndex, 0, tempIndex)
          // const targetRow = this.list.splice(evt.oldIndex, 1)[0]
          // this.list.splice(evt.newIndex, 0, targetRow)
          // // for show the changes, you can delete in you code
          // const tempIndex = this.newList.splice(evt.oldIndex, 1)[0]
          // this.newList.splice(evt.newIndex, 0, tempIndex)
        }
      })
    },
    addMainContent() {
      console.log(this.contractForm.emphasis)
      this.contractForm.content.push({
        content: '',
        strong: 'false',
        font: 2
      })
    },
    updatePhoto: function(photo, name) {
      this.$set(this.contractForm, name, photo)
    },
    fnGetTypeInfo() {
      this.$http.getOrderType().then(res => {
        this.orderType = res.data
      })
    },
    fnSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.contractForm.emphasis || this.contractForm.emphasis.length == 0) {
            this.$message({
              message: '须知为必传项',
              type: 'error'
            })
            return
          }
          if (!this.contractForm.content || this.contractForm.emphasis.content == 0) {
            this.$message({
              message: '正文内容为必传项',
              type: 'error'
            })
            return
          }
          if (!this.contractForm.order_type || this.contractForm.emphasis.order_type == 0) {
            this.$message({
              message: '套餐类型为必传项',
              type: 'error'
            })
            return
          }
          var postObj = Object.assign({}, this.contractForm)
          postObj.emphasis = JSON.stringify(postObj.emphasis)
          postObj.content = JSON.stringify(postObj.content)
          postObj.order_type = postObj.order_type.join(',')
          this.$http.improveContract(postObj).then(res => {
            if (res.code == 200) {
              this.$message.success('设置成功')
              this.$router.go(-1)
            }
          })
        } else {
          this.$message({
            message: '提交失败',
            type: 'error'
          })
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scope>
.contract-form {
  background-color: white;
  padding: 30px;
}
.wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.combo-group {
  .tuolele-main-search {
    .el-button {
      margin-left:0px!important
    }
    .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 20px !important;
    }
    .el-tabs--top .el-tabs__item.is-top:last-child {
      padding-right: 20px !important;
    }
    .el-form-item__label {
      font-size: 16px;
      color: #333;
    }
    .el-form-item__content {
      margin: 0 20px 0 12px;
    }
  }
}
</style>
